export default __webpack_public_path__ + "static/media/Heavenly Rain.4830119a.jpg";